import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchCart = async () => {
    if (!user?.email) {
      setCart([]);
      return;
    }

    try {
      const res = await fetch(
        `https://ankit1.jaskart.com/cart?email=${encodeURIComponent(user.email)}`
      );
      const data = await res.json();
      setCart(data);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔁 load cart on app start & login change
  useEffect(() => {
    fetchCart();
  }, [user?.email]);

  const addToCart = async (item) => {
    const res = await fetch("https://ankit1.jaskart.com/cart/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(item),
    });

    const data = await res.json();
    if (data.cart) setCart(data.cart); // 🔥 instant update
  };

  const updateQuantity = async (id, weight, quantity) => {
    if (quantity < 1) return;

    setCart(prev =>
      prev.map(item =>
        item.id === id && item.weight === weight
          ? { ...item, quantity }
          : item
      )
    );

    await fetch("https://ankit1.jaskart.com/cart/update", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, weight, quantity }),
    });
  };

  const removeFromCart = async (id, weight) => {
    setCart(prev =>
      prev.filter(item => !(item.id === id && item.weight === weight))
    );

    await fetch("https://ankit1.jaskart.com/cart/delete", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, weight }),
    });
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        updateQuantity,
        removeFromCart,
        refreshCart: fetchCart, // ✅ exposed
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
